import { render } from "./EntryManually.vue?vue&type=template&id=3a74a830&scoped=true"
import script from "./EntryManually.vue?vue&type=script&lang=js"
export * from "./EntryManually.vue?vue&type=script&lang=js"

import "./EntryManually.vue?vue&type=style&index=0&id=3a74a830&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a74a830"]])

export default __exports__